<ul class="breadcrumb">
    <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">ESTÁS EN </span>Inicio</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li><a [routerLink]="['/configuration/entities']">Configuración</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li><a [routerLink]="['/configuration/organizationsTypes']">Tipos de organización</a></li>
</ul>
<p-card styleClass="p-card-content-fit">
    <ng-template pTemplate="header">
        <div class="p-card-title">
            Tipos de organización
            <div class="p-card-title-actions">
                <a (click)="edit(null)">
                    <fa-icon [icon]="['fas', 'plus-circle']"></fa-icon>Nuevo tipo de organización
                </a>
            </div>
        </div>
    </ng-template>
    <div class="p-grid">
        <div class="p-col-12">
            <p-table #grid [value]="organizationsTypes" [lazy]="true" (onLazyLoad)="loadData($event)">
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="name" style="width: 75%;">Nombre</th>
                        <th width="100"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-organizationType>
                    <tr (dblclick)="edit(organizationType)">
                        <td>{{organizationType.name}}</td>
                        <td class="grid-actions">
                            <a (click)="edit(organizationType)">
                                <fa-icon [icon]="['far', 'edit']"></fa-icon>
                            </a>
                            <a (click)="delete(organizationType)" class="color-danger">
                                <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
                            </a>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</p-card>
